import { render, staticRenderFns } from "./adicionarComentario.vue?vue&type=template&id=144faae4"
import script from "./adicionarComentario.vue?vue&type=script&lang=js"
export * from "./adicionarComentario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports